module.exports = __webpack_public_path__ + "images/bookmark-outline-31b3f9d6.svg";